import { render } from "./report-receipt.vue?vue&type=template&id=07e268a9"
import script from "./report-receipt.vue?vue&type=script&lang=js"
export * from "./report-receipt.vue?vue&type=script&lang=js"

import "./report-receipt.vue?vue&type=style&index=0&id=07e268a9&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__